ui-offcanvas-trigger {
  display: inline;
}
